var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconGuide48Line = function SvgIconGuide48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 34.3H11v3.4h26v-3.4ZM13.9 31.71c-.76 0-1.5-.3-2.05-.85-.69-.68-.98-1.66-.8-2.61l.89-4.5c.06-.33.23-.64.47-.87l11.72-11.72a2.903 2.903 0 0 1 4.1 0l3.33 3.33a2.903 2.903 0 0 1 0 4.1L19.84 30.31c-.24.24-.54.4-.87.47l-4.5.89c-.19.04-.38.05-.56.05l-.01-.01Zm1.28-6.8-.64 3.26 3.26-.64 11-11-2.62-2.62-11 11Z",
    fill: "current"
  })));
};
export default SvgIconGuide48Line;